import { IApplicationState } from '../../../types/redux';

/**
 * Выбирает пользователя
 */
export const selectUser = ({ userNew }: IApplicationState) => userNew;
